function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './HeroSecondary.css';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors, injectImageResolution } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
/* import { tealiumClickFunc } from '../../utils/tealium'; */
import { useHistory } from 'react-router-dom';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import { isNil } from '../../utils/IsNil';
import Video from '../atoms/Video';
import { ReactComponent as IconPlaySharedCh } from '../../resources/icons/IconPlaySharedCh.svg';
import { useVideoModal } from '../atoms/VideoModal/VideoModal';
import { RenderVideo } from '../atoms/VideoModal/RenderVideo';
const HeroSecondary = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const {
    fields,
    params
  } = props;
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const carouselSpeed = get(params, 'timeout');
  const timing = carouselSpeed ? Number(carouselSpeed) * 1000 : 7000;
  const {
    modalVideoState,
    setModalVideoState,
    isShown,
    toggle,
    checkMouseMoved,
    startOnce,
    setStartOnce
  } = useVideoModal();
  /* const rtl: boolean = Boolean(sitecoreContext && sitecoreContext.rtl); */
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const heroWrapperRef = useRef(null);
  const [isVdsite, setIsVdsite] = useState(true);
  const dataItem = get(fields, 'data.item.children', [])[0];
  const src = get(dataItem, 'image.jss.value.src', '');
  const alt = get(dataItem, 'image.jss.value.alt', '');
  const title = get(dataItem, 'title.jss');
  const hasTitle = get(dataItem, 'title.jss.value');
  const intro = get(dataItem, 'description.jss');
  const hasIntro = get(dataItem, 'description.jss.value');
  const primaryCtaHref = get(dataItem, 'cTALink.jss.value.href');
  const primaryCtaLabel = get(dataItem, 'cTALinkLabel.jss.value');
  const primaryCtaTarget = get(dataItem, 'cTALink.jss.value.target');
  const primaryCtaLinktype = get(dataItem, 'cTALink.jss.value.linktype');
  const primaryCtaLinkAnchor = get(dataItem, 'cTALink.jss.value.anchor');
  const primaryCtaLinkLeftIcon = get(dataItem, 'ctaLeftIcon.targetItem.svg.jss.value');
  const primaryCtaLinkRightIcon = get(dataItem, 'ctaRightIcon.targetItem.svg.jss.value');
  const videoSrc = get(dataItem, 'video.jss.value.href', '');
  const videoType = get(dataItem, 'video.jss.value.linktype');
  const modalVideoDesk = get(dataItem, 'secondaryVideoLink.jss.value', {});
  const modalVideoMobile = get(dataItem, 'secondaryMobileVideoLink.jss.value', {});
  const [iconplay, setIconPlay] = React.useState(true);
  const [videoTeaserAutoPlay, setVideoTeaserAutoPlay] = useState(true);
  const history = useHistory();
  const firstTime = useRef(true);
  const actualSSR = process.env.STORYBOOK_MODE ? false : sitecoreContext.route && sitecoreContext.route.fromSSR;
  const isMobile = useMemo(() => {
    return !actualSSR && canUseDOM && window.matchMedia(`(max-width: 991px)`).matches;
  }, [actualSSR]);
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const GradientColor = get(params, 'GradientColorHex');
  let gradient = null;
  if (BackgroundColorHex && BackgroundColorHex.length && GradientColor && GradientColor.length) {
    gradient = "hbxrlk6";
  }
  const handleAutoPlay = () => {
    setIconPlay(a => !a);
  };
  const autoplayBtn = () => {
    return get(dataItem, 'video.jss.value.href', '') ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: `m113-interactive-banner__autoplay ${get(dataItem, 'video.jss.value.href', '') && 'autoplaySingle'} ${!iconplay && 'paused'}`,
      onClick: () => {
        setVideoTeaserAutoPlay(!videoTeaserAutoPlay);
        handleAutoPlay();
      }
    }, /*#__PURE__*/React.createElement("div", {
      id: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: `icon ${!iconplay && 'paused'}`
    }), iconplay ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      id: "halfclip"
    }, /*#__PURE__*/React.createElement("div", {
      className: "halfcircle",
      id: "clipped"
    })), /*#__PURE__*/React.createElement("div", {
      className: "halfcircle",
      id: "fixed"
    })) : /*#__PURE__*/React.createElement(React.Fragment, null))) : /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  const variables = BackgroundColorHex ? {
    '--m57-hero-secondary-background-color': BackgroundColorHex,
    '--m57-hero-secondary-background-active-color': ActiveColorHex,
    '--m57-hero-secondary-color': ColorHex
  } : {
    '--m57-hero-secondary-background-color': selectedPrimaryColor,
    '--m57-hero-secondary-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m57-hero-secondary-color': getColorByTheme(selectedPrimaryColor)
  };
  Object.assign(variables, {
    '--m113-interactive-banner-timing': `${timing / 1000}s`,
    '--m113-interactive-banner-half-timing': `${timing / 1000 / 2}s`
  });
  const variablesWithoutImage = BackgroundColorHex ? {
    '--m57-hero-secondary-without-image-title-color': ColorHex,
    '--m57-hero-secondary-without-image-intro-color': ColorHex,
    '--m57-hero-secondary-without-image-background-color': BackgroundColorHex
  } : {
    '--m57-hero-secondary-without-image-title-color': '#000',
    '--m57-hero-secondary-without-image-intro-color': '#40484F',
    '--m57-hero-secondary-without-image-background-color': 'linear-gradient(180deg, #fff 0%, var(--main-color) 100%)'
  };
  if (!fields || !dataItem) {
    console.info('Hero component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [Hero component is empty: please provide data source]");
    }
    return null;
  }
  const scroolToElement = () => {
    if (heroWrapperRef.current) {
      window.scrollTo({
        top: window.scrollY + heroWrapperRef.current.getBoundingClientRect().bottom,
        behavior: 'smooth'
      });
    }
  };
  const anchorHandler = (anchor, primaryCtaHref) => {
    if (isNil(anchor) || anchor.trim() === '') {
      return;
    }
    if (history.location.pathname.toLocaleLowerCase().includes(primaryCtaHref.split('#')[0].toLocaleLowerCase())) {
      setTimeout(() => {
        const anchorElement = document.querySelector(`[data-anhor=${anchor}]`);
        anchorElement && anchorElement.scrollIntoView({
          behavior: 'smooth'
        });
        setTimeout(() => {
          const anchorElement = document.querySelector(`[data-anhor=${anchor}]`);
          anchorElement && anchorElement.scrollIntoView({
            behavior: 'smooth'
          });
          if (firstTime.current) {
            setTimeout(() => {
              if (Math.abs(anchorElement.getBoundingClientRect().y) > 5) {
                anchorElement && anchorElement.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }, 1000);
            firstTime.current = false;
          }
        }, 200);
      }, 200);
    } else return;
  };
  const commonStyles = isSharedCh ? "c1edly01" : "c1n3fwip";
  const commonStylesWithoutImage = isSharedCh ? "ce22z1i" : "cju20vn";
  const ltrStyles = isSharedCh ? "lwz0mko" : "l15ot8zc";
  const rtlStyles = isSharedCh ? "r1dd9uob" : "r8tqp84";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter'],
    className: `${src || videoSrc && isSharedCh ? commonStyles : commonStylesWithoutImage} ${rtl ? rtlStyles : ltrStyles} ${GradientColor && gradient && GradientColor.length && isSharedCh && (!src || !videoSrc) ? gradient : ''}`,
    style: _objectSpread(_objectSpread(_objectSpread({}, variables), variablesWithoutImage), {}, {
      '--startColor': BackgroundColorHex,
      '--endColor': GradientColor
    }),
    fullWidth: (!src || !videoSrc) && isSharedCh ? false : true
  }, () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hero",
    ref: heroWrapperRef
  }, isSharedCh && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `mouse mouse-1 ${get(dataItem, 'video.jss.value.href', '') ? 'mouse-carousel' : ''}`,
    onClick: scroolToElement
  }), get(dataItem, 'video.jss.value.href', '') && autoplayBtn()), src && /*#__PURE__*/React.createElement(LazyPicture, {
    className: "hero-secondary-image"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: `${injectImageResolution(src, 1920, 888)}`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${injectImageResolution(src, 750, 1164)}`,
    alt: alt,
    className: "slider__image"
  })), isSharedCh && videoSrc && videoType && /*#__PURE__*/React.createElement(Video, {
    buttonTopAlignment: true,
    videoSrc: videoSrc,
    videoType: videoType,
    click: e => tealiumClickFunc(params, `${e}: ${videoSrc}`),
    muted: true,
    autoplay: videoTeaserAutoPlay,
    videoFullHeight: true,
    isSharedCh: isSharedCh
  }), /*#__PURE__*/React.createElement("div", {
    className: "texts"
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: "title",
    field: title
  }), hasIntro && /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "intro",
    field: intro
  }), (modalVideoDesk.linktype || modalVideoMobile.linktype) && isSharedCh ? /*#__PURE__*/React.createElement("span", {
    className: 'btn__icon--desktop',
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [hasTitle]);
      let finalVideo;
      if (isMobile) {
        finalVideo = modalVideoMobile.linktype ? modalVideoMobile : modalVideoDesk;
      } else {
        finalVideo = modalVideoDesk.linktype ? modalVideoDesk : modalVideoMobile;
      }
      setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
        type: finalVideo.linktype,
        src: finalVideo.href,
        title: hasTitle
      }));
      toggle();
    }
  }, /*#__PURE__*/React.createElement(IconPlaySharedCh, null)) : /*#__PURE__*/React.createElement("div", {
    className: "empty-Place-play-btn"
  }), /*#__PURE__*/React.createElement("div", {
    className: "btns-wrapper"
  }, primaryCtaHref && primaryCtaLabel && /*#__PURE__*/React.createElement(RouterLink, {
    href: primaryCtaHref,
    className: "btn btn-secondary btn-secondary-mono",
    isSharedCh: isSharedCh,
    ctaLeftIcon: primaryCtaLinkLeftIcon,
    ctaRightIcon: primaryCtaLinkRightIcon,
    title: primaryCtaLabel,
    linksTarget: primaryCtaTarget,
    linktype: primaryCtaLinktype,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [hasTitle, primaryCtaLabel]);
      anchorHandler(primaryCtaLinkAnchor, primaryCtaHref);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn__text-wrapper"
  }, primaryCtaLabel)), get(dataItem, 'video.jss.value.href', '') && isSharedCh && /*#__PURE__*/React.createElement("div", {
    className: "empty-Place"
  })), /*#__PURE__*/React.createElement(RenderVideo, {
    modalVideoState: modalVideoState,
    isSharedCh: isSharedCh,
    isShown: isShown,
    setModalVideoState: setModalVideoState,
    toggle: toggle,
    checkMouseMoved: checkMouseMoved,
    startOnce: startOnce,
    setStartOnce: setStartOnce
  })))));
};
export default HeroSecondary;